import http from "@/helper/http";
import api from "@/helper/api";

export default {
  state: {
    services: [],
    loadingServices: false,
    loadingAddService: false,
    loadingEditService: false,
    loadingDeleteService: false,
  },
  mutations: {
    SET_SERVICES(state, services) {
      state.services = services;
    },
    SET_LOADING_SERVICES(state, loadingServices) {
      state.loadingServices = loadingServices;
    },
    SET_LOADING_ADD_SERVICE(state, loadingAddService) {
      state.loadingAddService = loadingAddService;
    },
    SET_LOADING_EDIT_SERVICE(state, loadingEditService) {
      state.loadingEditService = loadingEditService;
    },
    SET_LOADING_DELETE_SERVICE(state, loadingDeleteService) {
      state.loadingDeleteService = loadingDeleteService;
    },
  },
  actions: {
    getServices({ commit }, { storeId, page = 1, per_page = 10, query = "" }) {
      commit("SET_LOADING_SERVICES", true);
      return new Promise((resolve, reject) => {
        http
          .get(`${api.get_all_services}/${storeId}`, {
            params: {
              page,
              per_page,
              query,
            },
          })
          .then((res) => {
            commit("SET_SERVICES", res.data);
            commit("SET_LOADING_SERVICES", false);
            resolve(res.data);
          })
          .catch((err) => {
            commit("SET_LOADING_SERVICES", false);
            reject(err);
          });
      });
    },
    addService({ commit }, { service }) {
      commit("SET_LOADING_ADD_SERVICE", true);
      return new Promise((resolve, reject) => {
        http
          .post(api.store_service, service)
          .then((res) => {
            commit("SET_LOADING_ADD_SERVICE", false);
            resolve(res.data.data);
          })
          .catch((err) => {
            commit("SET_LOADING_ADD_SERVICE", false);
            reject(err);
          });
      });
    },
    editService({ commit }, { service }) {
      commit("SET_LOADING_EDIT_SERVICE", true);
      return new Promise((resolve, reject) => {
        http
          .patch(api.store_service, service)
          .then((res) => {
            commit("SET_LOADING_EDIT_SERVICE", false);
            resolve(res.data.data);
          })
          .catch((err) => {
            commit("SET_LOADING_EDIT_SERVICE", false);
            reject(err);
          });
      });
    },
    deleteService({ commit }, { service_id }) {
      commit("SET_LOADING_DELETE_SERVICE", true);
      return new Promise((resolve, reject) => {
        http
          .delete(api.store_service, {
            data: {
              service_id,
            },
          })
          .then((res) => {
            commit("SET_LOADING_DELETE_SERVICE", false);
            resolve(res.data.data);
          })
          .catch((err) => {
            commit("SET_LOADING_DELETE_SERVICE", false);
            reject(err);
          });
      });
    },
  },
  getters: {
    services: (state) => state.services,
    loadingServices: (state) => state.loadingServices,
    loadingAddService: (state) => state.loadingAddService,
    loadingEditService: (state) => state.loadingEditService,
    loadingDeleteService: (state) => state.loadingDeleteService,
  },
};
